import {PropsWithChildren} from 'react';

export default function GuestLayout({children}: PropsWithChildren) {
    return (
        <main className={'flex flex-col min-h-svh'}>
            {children}
        </main>
    );
}
